// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3YLiR","navLink":"header_navLink__2s9f1","ToggleBtn":"header_ToggleBtn__2SMEJ","menuBg":"header_menuBg__j83mi"};